module.exports = {"id":"208777","name":"Óliver Torres","rating":"79","photo":"./data/images/photos/1/208777.png","club":{"name":"FC Porto","logo":"./data/images/clubs/FCPorto.png"},"positions":["MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OliverTorres0.json
// module id = 3268
// module chunks = 0